module.exports = __webpack_public_path__ + "img/megaphone-bleuvert.e6a990d6.svg";